<template>
  <div class="refer-friends">
    <h1 class="refer-friends__title">
      {{ $t('referFriends.title') }}
    </h1>
    <p class="refer-friends__subtitle" v-html="$t('referFriends.subtitle')" />

    <h2 class="refer-friends__instructions">
      {{ $t('referFriends.instructions') }}
    </h2>

    <p class="refer-friends__text--strong">
      {{ $t('referFriends.textStep-1') }}
    </p>

    <referral-link />

    <p class="refer-friends__step" v-html="$t('referFriends.textStep-2')" />

    <p class="refer-friends__step" v-html="$t('referFriends.textStep-3')" />

    <p class="refer-friends__step" v-html="$t('referFriends.textStep-4')" />

    <div class="refer-friends__progress">
      <span class="refer-friends__progress-title">{{
        $t('referFriends.progressTitle')
      }}</span>
      <div class="refer-friends__progress-bar">
        <div
          class="refer-friends__progress-bar--bg"
          :style="{
            width: Math.floor((referredFriendsBarLength / 5) * 100) + '%',
          }"
        ></div>
      </div>
      <span>{{
        $t('referFriends.referredFriendsLength', {
          referredFriendsLength: referredFriends.length,
        })
      }}</span>
    </div>

    <p class="refer-friends__note">
      {{ $t('referFriends.note') }}
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ReferralLink from '@/components/ReferralLink.vue'
import NetworkService from '@/services/NetworkService'

export default {
  name: 'ReferFriends',
  components: { ReferralLink },
  data() {
    return {
      selectedSubtopic: '',
      copyMessage: this.$root.$t('referFriends.copyMessage'),
      referredFriends: [],
    }
  },
  async mounted() {
    const {
      data: { referredFriends },
    } = await NetworkService.getReferredFriends()
    this.referredFriends = referredFriends
  },
  computed: {
    ...mapGetters({ mobileMode: 'app/mobileMode' }),
    referredFriendsBarLength() {
      if (this.referredFriends.length > 5) return 5
      else return this.referredFriends.length
    },
  },
}
</script>

<style lang="scss" scoped>
h1,
h2,
p {
  margin: 0;
  padding: 0;
}

p {
  @include font-category('body');
}

.refer-friends {
  border-radius: 8px;
  background-color: #fff;
  padding: 1.8em 3em 3em;
  margin: 1em;
  text-align: left;

  @include breakpoint-above('medium') {
    max-width: 1000px;
    margin: 3em 3em 0 3em;
  }

  &__title {
    @include font-category('display-small');
    @include breakpoint-above('medium') {
      margin-top: 24px;
    }
    color: initial;
  }

  &__instructions {
    @include font-category('heading');
    font-weight: 700;
  }

  &__subtitle {
    @include font-category('body');
    margin-bottom: 2em;
    margin-top: 1em;
  }

  &__text--strong {
    font-weight: 600;
  }

  &__text--rewards {
    font-weight: 700;
  }

  &__survey-link {
    color: $c-success-green;
    text-decoration: underline;
  }

  &__step {
    margin-top: 2.2em;
  }

  &__note {
    font-style: italic;
  }

  &__money-bag {
    @include font-category('display-small');
  }

  &__progress {
    margin: 2em 0;
    @include flex-container(column);

    @include breakpoint-above('medium') {
      @include flex-container(row, flex-start, center);
    }

    &-title {
      @include breakpoint-above('medium') {
        margin-left: 4em;
      }

      font-weight: 600;
    }

    &-bar {
      width: 50%;
      border: none;
      border-radius: 10rem;
      height: 20px;
      grid-column-start: span 3;
      position: relative;
      background-color: $c-background-grey;
      margin: 1em 0;

      @include breakpoint-above('small') {
        width: 30%;
      }

      @include breakpoint-above('medium') {
        width: 20%;
        margin: 0 2em;
      }

      &--bg {
        width: 40%;
        background-color: $c-success-green;
        height: 100%;
        border-radius: 10rem;
      }

      &--number {
        color: white;
      }

      &--number-center {
        position: absolute;
        left: 0;
        right: 0;
        color: $c-soft-black;
      }
    }
  }
}

html.is-rtl {
  .refer-friends {
    text-align: right;

    &__progress {
      &-title {
        @include breakpoint-above('medium') {
          margin-right: 4em;
          margin-left: unset;
        }
      }
    }
  }
}
</style>
